'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const moment=require('pulsar-utils/dist-es6/time/moment');let

ParamSyncService=function(_BaseService){_inherits(ParamSyncService,_BaseService);_createClass(ParamSyncService,null,[{key:'$inject',get:function()
{
return['$state','$location'];
}}]);

function ParamSyncService($state,$location){_classCallCheck(this,ParamSyncService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._$state=$state;
_this._$location=$location;return _this;
}ParamSyncService.prototype.

start=function start(controller,$scope,onUrlChange){var _this2=this;
let stateName=_.get(this._$state,'current.name');
let lastKnownUrl=this._$location.url();
$scope.$on('$locationChangeSuccess',function(){
if(!_this2._$state.is(stateName)||lastKnownUrl===_this2._$location.url())
return;

let stateParams=_.get(_this2._$state,`params`);
onUrlChange(stateParams);
lastKnownUrl=_this2._$location.url();
});

return function(updatedParamsObject){
if(!_this2._$state.is(stateName))
return;

_this2._$state.go(stateName,updatedParamsObject);
};
};return ParamSyncService}(BaseService);


const IntervalSeparator='-to-';
const SerializedISOStringRegExpString='[\\d-]{10}T[\\d\\w\\:.]+';
const SerializedIntervalRegExp=new RegExp(`^${SerializedISOStringRegExpString}${IntervalSeparator}${SerializedISOStringRegExpString}$`);

const Synchronizers=[{
name:'Guid',
toUrl:function(val){return val.toString()},
fromUrl:function(valString){return Guid.fromString(valString)},
is:function(instance){return instance instanceof Guid},
equals:function(val1,val2){return val1.toString()===val2.toString()}},
{
name:'GuidString',
toUrl:function(val){return val},
fromUrl:function(val){return Guid.fromString(val)?val:void 0},
equals:function(val1,val2){return val1===val2},
is:function(val){return typeof val=='string'}},
{
name:'Date',
toUrl:function(val){return val.toISOString()},
fromUrl:function(val){
const asDate=new Date(val);
return Number.isNaN(asDate.getTime())?void 0:asDate;
},
equals:function(val1,val2){return val1.valueOf()===val2.valueOf()},
is:function(val){return val instanceof Date}},
{
name:'TimeInterval',
toUrl:function(val){return`${val.start.toISOString()}${IntervalSeparator}${val.end.toISOString()}`},
fromUrl:function(intervalString){
if(!SerializedIntervalRegExp.test(intervalString)){
return;
}

let[start,end]=intervalString.split(IntervalSeparator);
start=new Date(start);
end=new Date(end);
if(Number.isNaN(start.valueOf())||Number.isNaN(end.valueOf())){
return;
}

return TimeInterval.from(start).to(end);
},
equals:function(interval1,interval2){return interval1.equals(interval2)},
is:function(instance){return instance instanceof TimeInterval}},
{
name:'Timezone',
toUrl:function(timezone){return timezone},
fromUrl:function(timezoneString){
return _isTimezone(timezoneString)?timezoneString:void 0;
},
equals:function(timezone1,timezone2){return timezone1===timezone2},
is:function(timezone){return _isTimezone(timezone)}},
{
name:'NotificationType',
toUrl:function(notificationType){return notificationType.name},
fromUrl:function(notificationTypeString){
return _.find(NotificationType.All,{name:notificationTypeString});
},
equals:function(notificationType1,notificationType2){return notificationType1===notificationType2},
is:function(notificationType){return notificationType instanceof NotificationType}}];


function _isTimezone(timezone){
return typeof timezone=='string'&&_.exists(moment.tz.zone(timezone));
}

function _createUrlMatcherTypeDefinition(synchronizer){
let typeDef=_.merge({
encode:function(val){return encodeURIComponent(synchronizer.toUrl(val))},
decode:function(val){
try{
return synchronizer.fromUrl(decodeURIComponent(val));
}catch(e){
return;
}
}},
_.pick(synchronizer,['name','equals','is']));

return typeDef;
}

const SynchronizersAsUrlMatcherTypeDefinitions=Synchronizers.map(function(s){return _createUrlMatcherTypeDefinition(s)});

let _initialized=!1;
function _loadUrlMatcherTypes($urlMatcherFactoryProvider){
if(_initialized){
return;
}

for(let synchronizer of SynchronizersAsUrlMatcherTypeDefinitions){
$urlMatcherFactoryProvider.type(synchronizer.name,synchronizer);
}

_initialized=!0;
};

module.exports=ParamSyncService;
module.exports.Synchronizers=_.keyBy(SynchronizersAsUrlMatcherTypeDefinitions,'name');
module.exports.LoadUrlMatcherTypes=_loadUrlMatcherTypes;
//# sourceMappingURL=paramSyncService.js.map
